import React from 'react';
import { useCart } from '../context/CartContext';
import '../styles/Cart.css';

const FloatingCartButton: React.FC = () => {
  const { totalQty, openCart } = useCart();
  const [bump, setBump] = React.useState(false);

  React.useEffect(() => {
    const handler = () => {
      setBump(true);
      const t = setTimeout(() => setBump(false), 300);
      return () => clearTimeout(t);
    };
    window.addEventListener('cart:add' as any, handler as any);
    return () => window.removeEventListener('cart:add' as any, handler as any);
  }, []);

  return (
    <button onClick={openCart} className={`floating-cart-btn ${bump ? 'bump' : ''}`} aria-label="Abrir carrinho">
      <i className="bi bi-bag" aria-hidden="true"></i>
      {totalQty > 0 && <span className="badge">{totalQty}</span>}
    </button>
  );
};

export default FloatingCartButton;
